import React, { useState, useEffect } from 'react';
import ItemCard from './ItemCard';
import { IMAGE_BASE_URL } from '../constants/paths';
import { makeGetRequest } from '../services/httpHelper';
import { CircularProgress } from '@mui/material';
import ErrorHandler from '../services/ErrorHandler';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const GetInvolved = () => {
  const [opportunities, setOpportunities] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const church = JSON.parse(localStorage.getItem('church'));
  const navigate = useNavigate();

  useEffect(() => {
    const getVolunteeringOpportunities = async () => {
      try {
        setIsLoading(true);
        const res = await makeGetRequest('volunteer-opportunities/' + church.id);

        if (res && res.errorType) {
          setIsLoading(false);
          const errorMessage = ErrorHandler(res);
          setError(errorMessage);
        } else {
          setOpportunities(res.data);
          setIsLoading(false);
          setError(null);
        }
      } catch (error) {
        console.error('Error fetching volunteering opportunities:', error);
        setIsLoading(false);
        setError('Something went wrong while fetching data.');
      }
    };

    getVolunteeringOpportunities();
  }, [church.id]);

  const viewDetail = (opportunity) => {
    navigate(`/${church && church.website}/get-involved-detail`, {
      state: { opportunity: opportunity, opportunities },
    });
  };

  return (
    <>
      <Helmet>
        <title>Get Involved</title>
        <meta name="description" content="Volunteer opportunities at the church" />
        <link rel='canonical' href='/get-involved' />
      </Helmet>
      <div className='container my-5'>
        <h2 className='mb-4 text-center'>Get Involved</h2>

        {isLoading && (
          <div className='text-center my-4'>
            <CircularProgress />
          </div>
        )}

        {error && (
          <div className='alert alert-danger text-center' role='alert'>
            {error}
          </div>
        )}

        <div className='row'>
          {opportunities.length === 0 && !isLoading && !error && (
            <p className='text-muted text-center'>No volunteering opportunities right now. Please check back later.</p>
          )}

          {opportunities.map((opp) => (
            <div
              className='col-md-6 col-lg-4 mb-4 d-flex align-items-stretch'
              key={opp.id}
              style={{ cursor: 'pointer' }}
              onClick={() => viewDetail(opp)}
            >
              <ItemCard
                title={opp.title}
                text={opp.detail}
                img={IMAGE_BASE_URL + opp.image}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default GetInvolved;
